export enum AccountTypeOptions {
  SUPPLIER = 'SUPPLIER',
  COLLEAGUE = 'COLLEAGUE',
  CUSTOMER = 'CUSTOMER',
  DOMAIN = 'DOMAIN',
}
